import { ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import {
  HouseNumberInstitution,
  HouseNumberInstitutionSearch,
  UpdateHouseNumberInstitutionAssignment,
} from "../../models/HouseNumberInstitution";
import { SaveResult } from "../../models/Shared";

const apiUrlPrefix: string = "house-numbers";

export const getHouseNumberInstitutionFilteredList = async (
  search: HouseNumberInstitutionSearch
) => {
  return api.post(`${apiUrlPrefix}/search`, search) as Promise<
    PagedResult<HouseNumberInstitution>
  >;
};

export const saveHouseNumberInstitutionAssignment = async (
  save: UpdateHouseNumberInstitutionAssignment
) => {
  return api.post(`${apiUrlPrefix}/save`, save) as Promise<SaveResult<number>>;
};

export const getHouseNumberInstitutionListExport = async (
  search: HouseNumberInstitutionSearch,
  type: ExportTypeEnum
) => {
  return api.download(
    `${apiUrlPrefix}/export/${type}`,
    "post",
    search
  ) as Promise<any>;
};
